import styled from 'styled-components';

import { AccordionProps } from './props';

type AccordionWrapperProps = Pick<AccordionProps, 'width'>;

export const AccordionWrapper = styled.div<AccordionWrapperProps>`
  width: ${({ width }) => (width ? width : '100%')};
`;

type AccordionLabelProps = Pick<
  AccordionProps,
  'labelFontSize' | 'mobileLabelFontSize' | 'labelWeight'
>;

export const AccordionLabel = styled.span<AccordionLabelProps>`
  font-size: ${({ labelFontSize }) => (labelFontSize ? labelFontSize : '16px')};
  font-weight: ${({ labelWeight }) => (labelWeight ? labelWeight : 'bold')};
  width: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    font-size: ${({ mobileLabelFontSize }) =>
      mobileLabelFontSize ? mobileLabelFontSize : '14px'};
  }
`;

type AccordionHeaderProps = Pick<
  AccordionProps,
  | 'headerFullBorder'
  | 'alwaysShowBottomBorder'
  | 'borderRadius'
  | 'headerPadding'
  | 'backgroundColor'
  | 'headerContentColor'
  | 'borderColor'
  | 'showIconOnTop'
  | 'responsivePadding'
  | 'filterHeight'
>;

export const AccordionHeader = styled.div<AccordionHeaderProps>`
  width: 100%;
  display: flex;
  padding: ${({ headerPadding }) => (headerPadding ? headerPadding : '10px')};
  align-items: ${({ showIconOnTop }) =>
    showIconOnTop ? 'flex-start' : 'center'};
  justify-content: space-between;
  background: ${({ theme, backgroundColor }) =>
    backgroundColor ? theme.palette[backgroundColor] : 'transparent'};
  cursor: pointer;
  border: ${({ theme, headerFullBorder, borderColor }) =>
    headerFullBorder
      ? borderColor
        ? `1px solid ${theme.palette[borderColor]}`
        : `1px solid ${theme.palette.lightBlueGrey}`
      : 'none'};
  border-bottom: ${({ theme, borderColor, alwaysShowBottomBorder }) =>
    alwaysShowBottomBorder
      ? borderColor
        ? `1px solid ${theme.palette[borderColor]}`
        : `1px solid ${theme.palette.lightBlueGrey}`
      : 'none'};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '0px')};
  color: ${({ theme, headerContentColor }) =>
    headerContentColor
      ? theme.palette[headerContentColor]
      : theme.palette.white};
  height: ${({ filterHeight }) => (filterHeight ? '60px' : 'auto')};
  & > a {
    text-decoration: none !important;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    padding-bottom: ${({ responsivePadding }) =>
      responsivePadding ? responsivePadding : '12px !important'};
  }
`;

type AccordionContentProps = Pick<
  AccordionProps,
  | 'contentPadding'
  | 'borderRadius'
  | 'headerPadding'
  | 'backgroundColor'
  | 'headerContentColor'
  | 'borderColor'
  | 'showBodyBorder'
>;
export const AccordionContent = styled.div<
  AccordionContentProps & { isOpen?: boolean }
>`
  width: 100%;
  max-height: ${({ isOpen }) => (isOpen ? 'auto' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  padding: ${({ contentPadding }) =>
    contentPadding ? contentPadding : '10px'};
  overflow: hidden;
  transition: all 0.3s;
  background: ${({ theme, backgroundColor }) =>
    backgroundColor ? theme.palette[backgroundColor] : 'transparent'};
  border-left: ${({ theme, borderColor, showBodyBorder }) =>
    showBodyBorder
      ? borderColor
        ? `1px solid ${theme.palette[borderColor]}`
        : `1px solid ${theme.palette.lightBlueGrey}`
      : 'none'};
  border-right: ${({ theme, borderColor, showBodyBorder }) =>
    showBodyBorder
      ? borderColor
        ? `1px solid ${theme.palette[borderColor]}`
        : `1px solid ${theme.palette.lightBlueGrey}`
      : 'none'};
  border-bottom: ${({ theme, borderColor, showBodyBorder }) =>
    showBodyBorder
      ? borderColor
        ? `1px solid ${theme.palette[borderColor]}`
        : `1px solid ${theme.palette.lightBlueGrey}`
      : 'none'};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '0px')};
  font-size: 16px !important;
  font-weight: normal !important;
  && font span {
    font-size: 16px !important;
  }
`;
export const CustomIconWrapper = styled.div``;
